import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { RevenueBreakdownItem } from '@/types/reports';
import { useCompanyLocale } from '@/hooks/useCompanyLocale';

interface RevenueBreakdownProps {
  items: RevenueBreakdownItem[];
}

export const RevenueBreakdown = ({ items }: RevenueBreakdownProps) => {
  const { formatMoney } = useCompanyLocale();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Revenue Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index} className="border-b last:border-0">
                <TableCell className={item.isBold ? 'font-bold' : ''}>
                  {item.label}
                </TableCell>
                <TableCell className={`text-right ${item.isBold ? 'font-bold' : ''}`}>
                  {formatMoney(item.amount)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
